import { useEffect, useState } from "react";
import axios from "axios";
import { NAMES, LISTED_TICKERS } from "../data/mockData";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

// Seed rows so components render before the first fetch resolves.
const SEED = LISTED_TICKERS.map((t) => ({
  ticker: t,
  name: NAMES[t] || `${t} TOKEN`,
  pool: null,
  nav: null,
  session: "AH",
  vol: "—",
}));

let state = { listed: SEED, pairs: [], lastRead: null, ready: false };
const listeners = new Set();
let started = false;

async function tick() {
  try {
    const [listedRes, pairsRes] = await Promise.all([
      axios.get(`${API}/listed`, { timeout: 8000 }),
      axios.get(`${API}/pairs`,  { timeout: 8000 }),
    ]);
    const listed = listedRes.data;
    // Preserve canonical order + names when live data returns
    const byT = Object.fromEntries(listed.map((r) => [r.ticker, r]));
    const sorted = LISTED_TICKERS.map((t) => ({
      ...(byT[t] || SEED.find((s) => s.ticker === t)),
      name: NAMES[t] || byT[t]?.name || `${t} TOKEN`,
    }));
    state = {
      listed: sorted,
      pairs: pairsRes.data,
      lastRead: new Date(),
      ready: true,
    };
    listeners.forEach((fn) => fn(state));
  } catch (e) {
    // Silent: keep last good state.
    // eslint-disable-next-line no-console
    console.warn("useLive tick failed", e?.message);
  }
}

function ensureStarted() {
  if (started || typeof window === "undefined") return;
  started = true;
  tick();
  setInterval(tick, 4000);
}

export default function useLive() {
  const [s, setS] = useState(state);
  useEffect(() => {
    ensureStarted();
    const fn = (next) => setS(next);
    listeners.add(fn);
    setS(state);
    return () => { listeners.delete(fn); };
  }, []);
  return s;
}
